import { userPlanAtom } from 'app/atoms';
import { isFreeTrialPlanCode, useMyActivePlans } from 'app/network/plan';
import { useAtomValue } from 'jotai';
import { isAnyWhiteLabel } from 'app/utils/helpers';

export function useHasPartagePlusSubscription() {
  const isAvailable = !isAnyWhiteLabel();
  const { data: activePlans } = useMyActivePlans({ enabled: isAvailable });
  const activePlansFromAtom = useAtomValue(userPlanAtom);
  const resolvedPlans = activePlans ?? activePlansFromAtom;
  if (!isAvailable || resolvedPlans === null) return undefined;

  const now = new Date();
  return resolvedPlans.some(
    (plan) =>
      !isFreeTrialPlanCode(plan.code.code) && (!plan.expiresAt || new Date(plan.expiresAt).getTime() > now.getTime()),
  );
}
